import { FormSpy } from 'react-final-form';

import { Flex } from '@change-corgi/design-system-legacy/layout';

import type { FormRenderProps, PetitionUpdateFormValues } from '../../types';
import { DescriptionTextArea } from '../DescriptionTextArea';
import { ErrorMessage } from '../ErrorMessage';
import { ImageUploadContainer } from '../ImageUploadContainer';
import { PreviewEmailButton } from '../PreviewEmailButton';
import { SubmitButton } from '../SubmitButton';
import { TitleInput } from '../TitleInput';
import { UpdateHelpText } from '../UpdateHelpText';

export function FormRender({
	handleSubmit,
	initialValues,
	hasValidationErrors,
	onPreview,
	isCurrentlyLoading,
	uploader,
	error,
}: FormRenderProps) {
	return (
		<form onSubmit={handleSubmit} autoComplete="off" sx={{ marginTop: 24 }}>
			<Flex
				sx={{
					flexDirection: ['column', 'row'],
					flexWrap: 'wrap',
					justifyContent: 'flex-end',
				}}
				mb={64}
			>
				<TitleInput initialValue={initialValues.title} />
				<ImageUploadContainer uploader={uploader} />
				<DescriptionTextArea initialValue={initialValues.description} />
				{error && <ErrorMessage errorType={error} />}
				<Flex
					sx={{
						flexDirection: ['column', 'row'],
						flexWrap: 'wrap',
						justifyContent: 'flex-end',
						width: '100%',
					}}
					mb={64}
				>
					<UpdateHelpText />
					<FormSpy<PetitionUpdateFormValues> subscription={{ values: true }}>
						{(props) => (
							<PreviewEmailButton
								onClick={async () => onPreview(props.values)}
								disabled={hasValidationErrors || isCurrentlyLoading}
							/>
						)}
					</FormSpy>
					<SubmitButton hasValidationErrors={hasValidationErrors} loading={isCurrentlyLoading} />
				</Flex>
			</Flex>
		</form>
	);
}
